import React from 'react';
import { useTranslation } from 'react-i18next';
import { useProjectModal } from './ProjectModal/ProjectModalContext';

const Cta = () => {
  const { t } = useTranslation();
  const { open } = useProjectModal();

  return (
    <section className="py-20 lg:py-28 bg-white">
      <div className="container-x">
        <div className="relative overflow-hidden rounded-3xl cta-surface px-8 py-14 lg:px-16 lg:py-20 text-center lg:text-left" data-aos="fade-up">
          <div className="relative flex flex-col lg:flex-row lg:items-center lg:justify-between gap-8">
            <div className="max-w-2xl">
              <h2 className="text-3xl md:text-4xl font-extrabold text-white leading-tight">{t('cta.title')}</h2>
              <p className="mt-4 text-lg text-brand-100/90">{t('cta.subtitle')}</p>
            </div>
            <div className="flex-none">
              <button type="button" onClick={open} className="btn-primary !bg-white !text-ink hover:!bg-brand-50 group text-base !px-8 !py-4">
                {t('cta.buttonText')}
                <svg className="w-5 h-5 transition-transform group-hover:translate-x-1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"><path fillRule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clipRule="evenodd" /></svg>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Cta;
